module.exports = __webpack_public_path__ + "static/media/heat.1a41ea24.svg";